import { useAuth } from "../context/AuthContext";
import { Navigate } from "react-router-dom";

export default function AdminGuard({ children }) {
  const { user, loading } = useAuth();

  if (loading) return null;

  if (!user || user.role !== "queue_master") {
    return <Navigate to="/join" replace />;
  }

  return children;
}
